import type { PageProps, ResourcePageData } from "@/types";
import React, { FC } from "react";
import { Link } from "../link";
import {
  ResourcesCta,
  ResourcesFeaturedPost,
  ResourcesLatestPosts,
} from "../resources";
import { LatestNews } from "../home";

export const Resources: FC<PageProps<ResourcePageData>> = (props) => {
  return (
    <div>
      <div className="wrapper">
        <div className="resources--links">
          {props.meta.translation.header.resources.children.map(
            (item, itemIdx) => {
              return (
                <Link
                  key={itemIdx}
                  noStyle
                  href={item.link?.uri || "#"}
                  className="resources--link"
                >
                  {item.text}
                </Link>
              );
            }
          )}
        </div>
      </div>
      {props.data.featuredPost && (
        <ResourcesFeaturedPost
          tag={props.meta.translation.resources.feature}
          post={props.data.featuredPost}
          readMore={props.meta.translation.resources.readMore}
        />
      )}
      {props.data.latestInsights.length > 0 && (
        <ResourcesLatestPosts
          posts={props.data.latestInsights}
          title={props.meta.translation.resources.latestInsights}
          viewAll={props.meta.translation.resources.viewAllInsights}
          readMore={props.meta.translation.resources.readMore}
        />
      )}
      {props.data.latestNews.length > 0 && (
        <LatestNews
          title={props.meta.translation.home.latestNews.title}
          viewAll={props.meta.translation.home.latestNews.viewAll}
          posts={props.data.latestNews}
        />
      )}
      <div className="wrapper wrapper_lg">
        <ResourcesCta title={props.data.signupTitle} />
      </div>
      {props.data.latestBlogs.length > 0 && (
        <ResourcesLatestPosts
          posts={props.data.latestBlogs}
          title={props.meta.translation.resources.latestBlogs}
          viewAll={props.meta.translation.resources.viewAllBlogs}
          readMore={props.meta.translation.resources.readMore}
          className="resources--latestBlogs"
          theme="dark"
        />
      )}
    </div>
  );
};
